import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { StatusCodes } from 'http-status-codes';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ServerErrorService {

  NOINTERNET = 0;

  constructor(public router: Router, private zone: NgZone, public translateService: TranslateService) {
  }

  public processError(error: HttpErrorResponse) {

    switch (error.status) {
      case this.NOINTERNET:
        this.pageRedirect('/error-page', this.translateService.instant('translateStrings.check_internet_connection'), '');
        break;

      case StatusCodes.UNAUTHORIZED || StatusCodes.FORBIDDEN:
        this.pageRedirect('/error-page', this.translateService.instant('translateStrings.unauthorized'), '');
        break;

      case StatusCodes.INTERNAL_SERVER_ERROR:
        this.pageRedirect('/error-page', 'Internal Server Error', '');
        break;

      case StatusCodes.BAD_GATEWAY || StatusCodes.GATEWAY_TIMEOUT:
        this.pageRedirect('/error-page', 'Gate Way Time Out', '');
        break;

      case StatusCodes.NOT_FOUND:
        this.pageRedirect('/error-page', this.translateService.instant('translateStrings.we_cant_identify_product'), '');
        break;

      default:
        this.pageRedirect('/error-page', 'Sorry, there seems to be some technical issue due to which we are unable to fetch the details.', 'We are working on it and it will be up soon.');
        break;
    }
  }

  pageRedirect(url: string, errorMessage: any, errorDescription: any) {
    this.zone.run(() => this.router.navigate([url],
      {
        replaceUrl: true, queryParams: { message: errorMessage, description: errorDescription },
        queryParamsHandling: 'merge'
      }));
  }
}